import { httpAPI, getFileBlob, downloadFile } from '@/services/ajax';

export default {
    data() {
        return {
            AJAX_CACHE_KEY: 'apiCache',

            // AJAX_COMPANY_ID_OVERRIDE: number <- if set in component, forces the company_id key to be appended to outgoing HTTP requests
        };
    },
    methods: {
        $removeCacheKey(cacheKey) {
            const cacheJSON = localStorage.getItem(this.AJAX_CACHE_KEY);
            const cache = cacheJSON ? JSON.parse(cacheJSON) : {};
            delete cache[cacheKey];
            localStorage.setItem(this.AJAX_CACHE_KEY, JSON.stringify(cache));
        },

        $getData(path, data = null, useCache = false, cacheKey = 'default') {
            const url = this.$env.apiRoot + path;
            if (useCache) {
                const cacheJSON = localStorage.getItem(this.AJAX_CACHE_KEY);
                const cache = cacheJSON ? JSON.parse(cacheJSON) : {};

                if (!(cacheKey in cache)) cache[cacheKey] = {};

                if (!(path in cache[cacheKey])) {
                    cache[cacheKey][path] = {};
                }

                const dataStr = JSON.stringify(data);
                const timeNow = new Date();

                // Not cached, or 2 minutes have passed since last fetch
                if (
                    !(dataStr in cache[cacheKey][path]) ||
                    timeNow -
                        new Date(cache[cacheKey][path][dataStr].cached_at) >
                        2 * 60 * 1000
                ) {
                    return httpAPI(url, data, 'GET', this.$router).then(
                        (response) => {
                            cache[cacheKey][path][dataStr] = {
                                data: response,
                                cached_at: new Date(),
                            };
                            localStorage.setItem(
                                this.AJAX_CACHE_KEY,
                                JSON.stringify(cache)
                            );
                            return response;
                        }
                    );
                }

                return Promise.resolve(cache[cacheKey][path][dataStr].data);
            }

            return httpAPI(url, data, 'GET', this.$router);
        },

        $postData(path, data = null, stream = false, onChunk = null) {
            const url = this.$env.apiRoot + path;
            return httpAPI(url, data, 'POST', this.$router, stream, onChunk);
        },

        $deleteData(path, data = null) {
            const url = this.$env.apiRoot + path;
            return httpAPI(url, data, 'DELETE', this.$router);
        },

        $getFileBlob(data = null) {
            const url = this.$env.apiRoot + 'upload/serve';
            return getFileBlob(url, data);
        },

        $downloadFile(path = null, data = null) {
            const endpoint = path ? path : 'upload/serve';
            const url = this.$env.apiRoot + endpoint;
            return downloadFile(url, data);
        },
    },
};
